import { useEffect, useState } from 'react'

export const useMinute = (intervalMs = 60000) => {
  const [minute, setMinute] = useState(Date.now())

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMinute(Date.now())
    }, intervalMs)

    return () => {
      clearInterval(intervalId)
    }
  }, [intervalMs])

  return minute
}
